/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b572a863e87253ae5dbee82e4df6d6d9241f4ae7";
